import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ISystemPerfomCalculationPayload } from '../smokeExtraction/system/calculations/slice';
import { ISystemUpdatePayload } from '../smokeExtraction/system/slice';

export interface IAirExchangeTableItem {
  id: number;
  name: string;
  created_at: string;
  updated_at?: string;
  object_name?: string;
  project_name?: string;
  updater?:
    | {
        name?: string | null | undefined;
        email?: string | null | undefined;
        uuid?: string | null | undefined;
      }
    | null
    | undefined;
}

interface IAirExchangeTableExportJSON {
  id: number;
  name: string;
}

interface ConsumersItem {
  consumer_count: number;
  flow_per_consumer: number;
}

interface MO_TableItem {
  i: number | null;
  count?: number | null;
  flow_mo_inflow?: number | null;
  flow_mo_exhaust?: number | null;
  flow_inflow?: number | null;
  flow_exhaust?: number | null;
  sys_mo_inflow?: string | null;
  sys_mo_exhaust?: string | null;
}

export interface AirExchangeTableItem {
  id?: string;
  block?: string;
  floor?: string;
  num: string;
  name: string;
  area: number;
  height: number;
  volume: number;
  people_count?: number | null;
  multiplicity_inflow?: number | null;
  multiplicity_exhaust?: number | null;
  flow_inflow?: number | null;
  flow_exhaust?: number | null;
  flow_mo_inflow?: number | null;
  flow_mo_exhaust?: number | null;
  sys_inflow?: string | null;
  sys_exhaust?: string | null;
  sys_mo_inflow?: string | null;
  sys_mo_exhaust?: string | null;
  note?: string | null;
  inflow_consumers?: ConsumersItem[] | null;
  exhaust_consumers?: ConsumersItem[] | null;
  inflow_linked?: string | null;
  exhaust_linked?: string | null;
  mo_table?: MO_TableItem[] | null;
  type_balance?: string | null;
  type_inflow?: string | null;
  type_exhaust?: string | null;
}

export interface IAirExchangeTableList {
  items?: IAirExchangeTableItem[];
  pages?: number | null | undefined;
  page: number | null;
  size: number | null;

  total: number | null;
}

export interface IAirExchangeTableListFetchPayload {
  order_by?: string | null;
  page?: number | null;
  size?: number | null;
  search?: string | null;
}

interface IModalState {
  isRender: boolean;
  data?: any | null;
  systemID?: number | null;
}

export interface IAirExchangeTableState {
  airExchangeTableList: IAirExchangeTableList | null;
  airExchangeTableSystemModal: { isRender: boolean };
  addRoomModal: { isRender: boolean; data?: any };
  explicationModal: { isRender: boolean; systemID?: number | null };
  isSending: boolean;
}

const initialState: IAirExchangeTableState = {
  airExchangeTableList: null,
  airExchangeTableSystemModal: { isRender: false },
  addRoomModal: { isRender: false },
  explicationModal: { isRender: false, systemID: null },
  isSending: false,
};

export const airExchangeTableSlice = createSlice({
  name: 'airExchangeTable',
  initialState,
  reducers: {
    // air exchange list
    fetchAirExchangeTableList: (
      state,
      action: PayloadAction<IAirExchangeTableListFetchPayload>
    ) => ({
      ...state,
      payload: action.payload,
    }),

    setAirExchangeTableList: (
      state,
      action: PayloadAction<IAirExchangeTableList | null>
    ) => ({
      ...state,
      airExchangeTableList: action.payload,
    }),

    setAirExchangeTableSystemModal: (
      state,
      action: PayloadAction<any | null>
    ) => ({
      ...state,
      airExchangeTableSystemModal: action.payload,
    }),

    setAddRoomModal: (state, action: PayloadAction<IModalState>) => ({
      ...state,
      addRoomModal: action.payload,
    }),

    setExplicationModal: (state, action: PayloadAction<IModalState>) => ({
      ...state,
      explicationModal: action.payload,
    }),
    performAirExchangeTable: (
      state,
      action: PayloadAction<ISystemPerfomCalculationPayload>
    ) => ({
      ...state,
      payload: action.payload,
    }),

    updateNameSystem: (state, action: PayloadAction<ISystemUpdatePayload>) => ({
      ...state,
      payload: action.payload,
    }),

    importOfExplication: (state, action: PayloadAction<any>) => ({
      ...state,
      payload: action.payload,
    }),
    setIsSending: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isSending: action.payload,
    }),
    exportJSON: (
      state,
      action: PayloadAction<IAirExchangeTableExportJSON>
    ) => ({
      ...state,
      payload: action.payload,
    }),
    importJSON: (state, action: PayloadAction<any>) => ({
      ...state,
      payload: action.payload,
    }),
  },
});

export const airExchangeTableReducer = airExchangeTableSlice.reducer;
export const airExchangeTableActions = airExchangeTableSlice.actions;
